<template>
    <div style="display: flex; flex-direction: column; position: relative;">
        <Transition name="fade">
            <div v-if="isShowCompletePopup" style="position: fixed; background: #210F0380; left: 0; top: 0; width: 100%; height: 100%; z-index: 9999; backdrop-filter: blur(5px);">
                <div style="width: 350px; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <div style="position: relative;">
                        <img style="width: 100%; height: 100%; object-fit: cover; border-top-left-radius: 24px; border-top-right-radius: 24px; position: absolute; z-index: -1;" :src="$resourcePath + sliderImage[0].image_path" alt="">
                        <div style="color: #fff; text-align: center; padding-top: 40px;">
                            <div style="font-weight: 500; line-height: 24px;">{{ $Util.getMMDDDayHangulStr(scheduleDetail.join_begin_date_time) }} {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                            <div style="margin-top: 8px; font-weight: 700; font-size: 20px; line-height: 24px;">{{ scheduleDetail.title }}</div>
                        </div>
                        <div style="display: flex; align-items: center; gap: 8px; margin-top: 24px; justify-content: center; padding-bottom: 20px;">
                            <div>
                                <ProfileImage style="width: 60px;" :imagePath="scheduleDetail.creator.image_path"></ProfileImage>
                            </div>
                            <div style="display: flex; align-items: center; gap: 4px; color: #fff;">
                                <div style="font-weight: 700;">{{ scheduleDetail.creator.nic_name }}</div>
                                <div >
                                    <img v-if="scheduleDetail.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 16px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                    <img v-else style="width: 16px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 24px; padding: 0 20px; padding-bottom: 40px;">
                        <div style="text-align: center; font-weight: 700; font-size: 20px; line-height: 24px;">트레이닝이 신청됐습니다.<br>코치님께 준비물이 뭔지 물어보세요!</div>
                        <div style="display: flex; margin-top: 32px; gap: 12px;">
                            <div @click="closeCompletePopup" style="flex: 1; border-radius: 50px; height: 56px; line-height: 56px; text-align: center; font-size: 14px; font-weight: 700; background-color: #F5F5F5;">나중에 하기</div>
                            <div @click="showChat" style="flex: 1; border-radius: 50px; height: 56px; line-height: 56px; text-align: center; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">채팅 시작하기</div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
        <transition name="slide-up">
            <div :style="{ top: 66 + $GlobalStore.statusBarHeight() + 'px' }" v-if="isVisible && noticeList.length !== 0 && repeatScheduleInfo" class="notice-container">
                <div class="notice-content">
                    <div class="notice-label">공지</div>
                    <!-- <transition-group name="fade" tag="div" class="notice-text-container"> -->
                    <div class="notice-text-container">
                        <div :key="currentNotice.seq" class="notice-text">
                            <vue-marquee-slider ref="test" id="marquee-slider" :speed="10000" :autoWidth="true" :space="50" :paused="isPaused">
                                <div v-if="currentNotice">{{ currentNotice.contents }}</div>
                            </vue-marquee-slider>
                        </div>
                    </div>
                    <!-- </transition-group> -->
                </div>
            </div>
        </transition>
        <div style="display:flex; align-items: center; margin-top: 20px; position: relative; justify-content: space-between;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 12px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="position: absolute; font-weight: 700; font-size: 14px; left: 50%; transform: translateX(-50%);">
                트레이닝
            </div>
            <div v-if="$GlobalStore.isLogin()" @click="setIsShowPopMenu();" style="padding-right: 12px; display: flex; flex-direction: column; padding-left: 20px; gap: 3px; position: relative;">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
            </div>
        </div>
        <div v-if="Object.keys(scheduleDetail).length !== 0" style="flex: 1; margin-top: 14px; overflow-y: scroll; position: relative;">
            <div style="position: relative;">
                <swiper :options="swiperOption" role="tablist">
                    <swiper-slide v-for="each, i in sliderImage" style="height: 390px;" :key="i" role="tab">
                        <div style="position: relative; height: 100%;">
                            <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.image_path" alt="">
                        </div>
                    </swiper-slide>
                    <div v-if="bannerList.length !== 1" class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; display:inline-block;"></div>
                </swiper>
            </div>
            <div style="padding: 12px; font-weight: 500;">
                <div style="font-weight: 700; font-size: 20px; margin-top: 8px;">{{ scheduleDetail.title }}</div>
                <div style="font-size: 14px; line-height: 24px; margin-top: 8px; word-break: all; white-space: pre-wrap;">{{ scheduleDetail.contents }}</div>
            </div>
            <div class="hide_scroll" style="display: flex; overflow-x: scroll; margin-top: 10px; border-top: 1px solid #ededed; border-bottom: 1px solid #ededed; padding: 12px 20px">
                <!-- <div class="cont_wrap_box">
                            <div class="title">장소</div>
                            <div @click="showInMap" style="color: var(--color-main);" class="sub_title">지도에서 보기</div>
                            <div class="sub_title2">{{ scheduleDetail.place_name }}</div>
                        </div> -->
                <div style="" class="cont_wrap_box">
                    <div class="title">참여 인원</div>
                    <div class="sub_title">최대</div>
                    <div class="sub_title2">{{ scheduleDetail.max_cnt }}명</div>
                </div>
                <div style="padding-left: 16px" class="cont_wrap_box">
                    <div class="title">참여 비용</div>
                    <div class="sub_title">₩</div>
                    <div class="sub_title2">{{ scheduleDetail.dues | comma }}원</div>
                </div>
                <div style="padding-left: 16px" class="cont_wrap_box">
                    <div class="title">진행 시간</div>
                    <div class="sub_title">1회</div>
                    <div class="sub_title2">{{ $Util.getTimeGapStr(scheduleDetail.join_begin_date_time, scheduleDetail.join_end_date_time) }}</div>
                </div>
                <div style="padding-left: 16px" class="cont_wrap_box">
                    <div class="title">연령대</div>
                    <div class="sub_title">추천</div>
                    <div class="sub_title2">{{ scheduleDetail.recommend_age }}</div>
                </div>
                <div style="padding-left: 16px; border: none" class="cont_wrap_box">
                    <div class="title">성별</div>
                    <div class="sub_title">추천</div>
                    <div class="sub_title2">{{ scheduleDetail.sex }}</div>
                </div>
            </div>
            <div style="padding: 0 12px; margin-top: 20px; border-bottom: 32px solid #ebebeb; padding-bottom: 20px;">
                <div style="font-weight: 700; font-size: 14px; margin-bottom: 10px;">담당 코치</div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <div @click.stop="$Util.showProfile(scheduleDetail.creator_idx, scheduleDetail.creator_type, '', scheduleDetail.creator.is_coach); $Util.sendEventClick('지도_트레이닝_프로필_자세히보기')">
                        <ProfileImage style="width: 60px;" :imagePath="scheduleDetail.creator.image_path"></ProfileImage>
                    </div>
                    <div style="display: flex; align-items: center; gap: 3px;">
                        <div style="font-weight: 700;">{{ scheduleDetail.creator.nic_name }}</div>
                        <div>
                            <img v-if="scheduleDetail.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 16px;" :src="require('@/assets/img/blue_star.png')" alt="">
                            <img v-else style="width: 16px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                        </div>
                    </div>
                </div>
                <div style="margin-top: 44px; margin-bottom: 20px;">
                    <div style="display: flex; gap: 12px; align-items: center;">
                        <div>
                            <img style="width: 42px;" :src="require('@/assets/img/unique.png')" alt="">
                        </div>
                        <div style="display: flex; flex-direction: column; justify-content: space-between;">
                            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ scheduleDetail.explanation1 }}</div>
                            <div style="font-size: 12px; font-weight: 500; color: #606060; line-height: 20px;">{{ scheduleDetail.explanation2 }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div style="padding: 0 12px;">
                <div style="font-weight: 700; font-size: 14px; margin-top: 20px; margin-bottom: 12px;">일정</div>
                <div class="hide_scroll" style="display: flex; gap: 8px; overflow-x: scroll; margin: 0 -12px; padding: 0 12px;">
                    <div @click="selectSchedule(each.join_begin_date_time, each.idx)" :style="{ border: selectedSchedule === each.join_begin_date_time ? '1px solid var(--color-main)' : '1px solid #FFCBA8', backgroundColor: selectedSchedule === each.join_begin_date_time ? '#FFEADB' : '' }" style="width: 100px; height: 72px; border-radius: 12px; flex-shrink: 0; display: flex; gap: 6px; justify-content: center; align-items: center; flex-direction: column;" v-for="each, i in teamTrainingScheduleList" :key="i">
                        <div style="font-weight: 700; font-size: 14px;">{{ $Util.getMDDHangulStr(each.join_begin_date_time) }}</div>
                        <div style="font-size: 12px; font-weight: 500; color: #606060;">{{ each.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ each.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                    </div>
                </div>
            </div> -->
            <!-- <div style="padding: 0 12px;">
                <div style="font-weight: 700; font-size: 14px; margin-top: 20px;">다가오는 일정</div>
                <div style="height: 68px;background: #EBEBEB; margin-top: 10px; border-radius: 12px; display: flex; justify-content: center; align-items: center;">
                    <div style="display: flex; gap: 4px; align-items: center">
                        <img style="width: 17px;" :src="require('@/assets/img/schedule_black.png')" alt="">
                        <div style="font-weight: 700; font-size: 14px;">{{ scheduleDetail.join_date.split('-')[0] }}년 {{ transDate(scheduleDetail.join_date) }} {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                    </div>
                </div>
            </div> -->
            <div style="padding: 0 12px; border-bottom: 32px solid #ebebeb; padding-bottom: 20px;">
                <div style="display: flex; margin-top: 20px; gap: 12px;">
                    <div style="font-size: 14px; font-weight: 700; line-height: 24px;">참여 회원</div>
                    <div>
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px;">{{ scheduleDetail.cur_cnt }}명</div>
                        <div style="font-size: 12px; line-height: 20px; color: #606060;">{{ scheduleDetail.min_cancel_cnt - 1 }}명만 모여도 진행합니다.</div>
                    </div>
                </div>
                <div @touchmove.stop="() => { }" class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 16px; margin: 0 -12px; padding: 0 12px; margin-top: 10px">
                    <div style="display: flex; flex-direction: column; align-items: center;" v-for="each, i in scheduleMembers" :key="i">
                        <div @click="$Util.showProfile(each.member_idx, each.member_type, '', each.is_coach); $Util.sendEventClick('지도_트레이닝_프로필_자세히보기')">
                            <ProfileImage style="width: 60px;" :imagePath="each.image_path"></ProfileImage>
                        </div>
                        <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                            <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                            <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ $Util.position_display_str(each.member_type, each.position, each.is_coach) }}</div>
                        </div>
                    </div>
                    <div v-if="$GlobalStore.isLogin() && (!scheduleDetail.is_me_joined && scheduleDetail.state == JOIN_STATE.OPEN && $GlobalStore.loginInfo() && $GlobalStore.loginInfo().is_temp_coach != '1')" style="display: flex; flex-direction: column; align-items: center;">
                        <div class="circle_linear">
                            <div class="inner_circle"></div>
                        </div>
                        <div @click="showPayment(); $Util.sendEventClick('지도_트레이닝_트레이닝신청', true)" class="text_gradient" style="margin-top: 7px; font-size: 12px; font-weight: 700;">바로 참여하기</div>
                    </div>
                    <!-- <div style="width: 60px; height: 60px; border-radius: 50%; color: #606060; font-size: 24px; border: 1px solid #d9d9d9; background-color: #f5f5f5; flex-shrink: 0; display: flex; justify-content: center; align-items: center;" v-for="index in new Array(parseInt(scheduleDetail.max_cnt) - (scheduleDetail.cur_cnt))" :key="index">
                    </div> -->
                </div>
            </div>
            <div style="padding: 0 12px; padding-bottom: 20px; border-bottom: 32px solid #ebebeb;">
                <div style="font-weight: 700; line-height: 24px; margin-top: 32px; margin-bottom: 20px;">트레이닝 수준</div>
                <div style="border-radius: 12px; background-color: #f5f5f5; padding: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div style="font-weight: 700; line-height: 24px;">{{ scheduleDetail.level }}</div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #606060;">코치님이 설정한 훈련 강도 및 수준입니다</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 700; line-height: 24px; margin-bottom: 20px;">회원 평균 수준</div>
                    <div style="margin-bottom: 12px;">
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">실력:<span style="display: inline-block; margin-left: 12px; font-weight: 500;">{{ teamLevel }}</span></div>
                    </div>
                    <div style="display: flex; gap: 12px; padding-bottom: 32px; border-bottom: 2px solid #ebebeb;">
                        <div v-for="each, i in skillList" :key="i + 'skill'" style="flex: 1;">
                            <div style="background-color: #d9d9d9; border-radius: 8px; height: 60px; flex: 1; position: relative; overflow: hidden;">
                                <div :style="{ height: each.percent + '%' }" style="position: absolute; width: 100%; background: linear-gradient(180deg, #FF9A56 0%, #FFD4B6 100%); bottom: 0;"></div>
                            </div>
                            <div style="margin-top: 4px; line-height: 24px; font-size: 14px; font-weight: 700; text-align: center;">{{ each.percent }}%</div>
                            <div style="color: #808080; font-size: 12px; font-weight: 500; line-height: 20px; text-align: center;">{{ each.level }}<span v-if="each.cnt !== 0">({{ each.cnt }})</span></div>
                        </div>
                    </div>
                    <div style="margin-bottom: 12px; margin-top: 32px;">
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">구력:<span style="display: inline-block; margin-left: 12px; font-weight: 500;">{{ teamCareer }}</span></div>
                    </div>
                    <div style="display: flex; gap: 12px;">
                        <div v-for="each, i in careerList" :key="i + 'career'" style="flex: 1;">
                            <div style="background-color: #d9d9d9; border-radius: 8px; height: 60px; flex: 1; position: relative; overflow: hidden;">
                                <div :style="{ height: each.percent + '%' }" style="position: absolute; width: 100%; background: linear-gradient(180deg, #6ADCFF 0%, #BAEFFF 100%); bottom: 0;"></div>
                            </div>
                            <div style="margin-top: 4px; line-height: 24px; font-size: 14px; font-weight: 700; text-align: center;">{{ each.percent }}%</div>
                            <div style="color: #808080; font-size: 12px; font-weight: 500; line-height: 20px; text-align: center;">{{ each.level }}<span v-if="each.cnt !== 0">({{ each.cnt }})</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding: 0 12px; margin-bottom: 32px;">
                <!-- <div style="font-weight: 700; font-size: 14px; margin-top: 20px; display: flex; gap: 12px;">
                    <div>시간</div>
                    <div v-if="repeatScheduleInfo && repeatScheduleInfo.days" style="font-weight: 500; font-size: 14px;">매주 {{ transDays }} {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                    <div v-else style="font-weight: 500; font-size: 14px;">{{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                </div> -->
                <div style="font-weight: 700; font-size: 14px; margin-top: 32px; display: flex; gap: 12px;">
                    <div>장소</div>
                    <div style="font-weight: 500; font-size: 14px;">
                        <div>{{ scheduleDetail.place_name }}</div>
                        <div style="font-size: 12px;line-height: 20px; margin-top: 3px; color: #606060;">{{ scheduleDetail.address }}</div>
                    </div>
                    <div style="flex:1;"></div>
                    <div style="" @click="showInBrowser">
                        <div style="padding:0px 0px 5px 10px; color:var(--color-main); ">길찾기</div>
                    </div>
                </div>
                <div id="place_map" style="height: 156px; border-radius: 12px; margin-top: 20px;"></div>
                <div style="font-weight: 700;font-size: 14px;line-height: 24px; margin-top: 20px;">장소 사진</div>
                <div style="display: flex; gap: 12px; overflow-x: scroll; padding: 0 12px; margin: 0 -12px; margin-top: 8px; align-items: center;" class="hide_scroll">
                    <div v-for="each, i in groundImages" style="position: relative" :key="i" @click="showImageViewer(i)">
                        <img style="width: 200px; height: 200px; object-fit: cover; border-radius: 12px" :src="$resourcePath + each.src" alt="">
                    </div>
                </div>
            </div>
            <div style="height: 276px; padding: 0 12px; background-color: #ebebeb;">
                <div style="padding-top: 32px;">
                    <div @click="showInquiryPage(); $Util.sendEventClick('지도_트레이닝_문의하기')" style="display: flex; gap: 8px; position: relative;">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/counsel_new.png')" alt="">
                        </div>
                        <div>
                            <div style="font-weight: 700; line-height: 24px; margin-bottom: 4px;">궁금한 게 있으신가요?</div>
                            <div style="line-height: 24px; font-size: 14px; font-weight: 500; color: #606060;">사커하우 매니저에게 문의하기</div>
                        </div>
                        <div style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%);">
                            <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$GlobalStore.isLogin() && Object.values(scheduleDetail).length !== 0 && $GlobalStore.loginInfo().is_temp_coach != '1'" style="border-top: 1px solid #d9d9d9; position: relative; z-index: 10;">
            <div v-if="!scheduleDetail.is_me_joined && scheduleDetail.state == JOIN_STATE.OPEN" style="padding: 0 12px; height: 104px;">
                <div style="display: flex; margin-top: 8px; gap: 20px;">
                    <div style="flex-shrink: 0;">
                        <div style="font-weight: 700; font-size: 14px;"><span style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">{{ $Util.getMMDDDayHangulStrExceptionYYYY(scheduleDetail.join_begin_date_time) }}</span> {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                        <div :style="{ color: isClosed ? '#808080' : 'var(--color-main)' }" style="font-weight: 700; font-size: 20px; line-height: 24px;">{{ transText(scheduleDetail.join_begin_date_time, scheduleDetail.max_cnt, scheduleDetail.cur_cnt) }}</div>
                    </div>
                    <div :class="isClosed ? 'un_active' : 'active'" @click="showPayment(); $Util.sendEventClick('지도_트레이닝_트레이닝신청', true)" style="padding: 16px 0; flex: 1; font-weight: 700; font-size: 14px; line-height: 24px; border-radius: 12px; text-align: center;">{{ isClosed ? '마감됨' : (is_free ? '무료로 신청하기' : '신청하기') }}</div>
                </div>
            </div>
            <div v-else-if="scheduleDetail.is_me_joined && scheduleDetail.state == JOIN_STATE.OPEN" style="padding: 0 12px; height: 104px;">
                <div style="display: flex; margin-top: 8px; gap: 20px;">
                    <div style="flex-shrink: 0;">
                        <div style="font-weight: 700; font-size: 14px;"><span style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">{{ $Util.getMMDDDayHangulStrExceptionYYYY(scheduleDetail.join_begin_date_time) }}</span> {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
                        <div :style="{ color: isClosed ? '#808080' : 'var(--color-main)' }" style="font-weight: 700; font-size: 20px; line-height: 24px;">참여중</div>
                    </div>
                    <div @click="showChat" class="active" style="padding: 16px 0; flex: 1; font-weight: 700; font-size: 14px; line-height: 24px; border-radius: 12px; text-align: center;">채팅하기</div>
                </div>
            </div>
            <div v-else-if="scheduleDetail.is_me_joined && $GlobalStore.loginInfo() && $GlobalStore.loginInfo().is_temp_coach != '1'" style="padding:10px;">
                <div @click="showReservation" style="width: 166px; margin: 0 auto;" class="float_btn">
                    <div style="font-size: 14px;">예약 페이지 보기</div>
                </div>
            </div>
        </div>
        <EditModalFrame :isOpen="isShowRefund" :title="'취소 및 환불 규정'" :closeModal="closeRefund">
            <TeamTrainingCancelNotice style="max-height: 500px; overflow-y: scroll;" />
            <div @click="closeRefund" style="padding: 12px; background-color: #f5f5f5; border-radius: 12px; margin-top: 12px; text-align: center; font-weight: 700; font-size: 14px; line-height: 24px;">확인</div>
        </EditModalFrame>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <div style="position: relative; z-index: 100;">
            <ShareSchedule :schedule-idx="scheduleDetail.idx" :is-open="isShowShareSchedule" :close-complete-action="() => { isShowShareSchedule = false }" />
        </div>
        <transition name="fade" v-if="isShowWriteForm">
            <TeamTrainingWriteForm :getReplyList="getReplyList" :scheduleIdx="scheduleIdx" :closeWriteForm="closeWriteForm" :isShowTeamTrainingDetailWhenSave="false"></TeamTrainingWriteForm>
        </transition>
        <div>
            <TeamTrainingReviewWriteForm :repeatScheduleIdx="repeatScheduleIdx" :closeReviewWriteForm="closeReviewWriteForm" :isOpenReviewWriteForm="isOpenReviewWriteForm" :scheduleIdx="scheduleIdx"></TeamTrainingReviewWriteForm>
        </div>
        <BookmarkPopup :background="'#fff'" :height="280" :isShowBookmarkPopup="isShowReportPopup" :closeBookmarkPopup="() => { isShowReportPopup = false }">
            <div>
                <div @click="() => { isShowReportPopup = false }" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 12px;">해당 트레이닝을 신고할까요?</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">정확하지 않은 정보가 있거나 트레이닝 중<br>안좋은 경험을 했다면 신고할 수 있습니다.</div>
                    <div @click="reportTraining" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">신고하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :background="'#fff'" :height="256" :isShowBookmarkPopup="isShowSexPopup" :closeBookmarkPopup="() => { isShowSexPopup = false }">
            <div>
                <div @click="() => { isShowSexPopup = false }" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 32px;">추천 성별이 다른 트레이닝입니다.<br>정말 참여할까요?</div>
                    <div @click="joinTraining" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">참여하기</div>
                </div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :background="'#fff'" :height="280" :isShowBookmarkPopup="isShowFreeTrainingPop" :closeBookmarkPopup="() => { isShowFreeTrainingPop = false }">
            <div>
                <div @click="() => { isShowFreeTrainingPop = false }" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 12px;">무료로 진행되는 트레이닝입니다.</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">체험 및 이벤트로 진행되는 트레이닝이기<br>때문에 자유롭게 참여할 수 있습니다.<br>트레이닝을 참여할까요?</div>
                    <div @click="applyForFree" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">트레이닝 참여하기</div>
                </div>
            </div>
        </BookmarkPopup>
    </div>
</template>

<script>
import TeamTrainingReviewWriteForm from "@/components/common/TeamTrainingReviewWriteForm";
import moment from "moment"
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ProfileImage from '@/components/common/ProfileImage'
import ShareSchedule from "@/components/common/ShareSchedule";
import EditModalFrame from '@/components/modal/my/EditModalFrame';
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import ResponseCode from '@/ResponseCode'
import { JOIN_STATE, WRITE_TYPE } from '@/Constants'
import TeamTrainingCancelNotice from "./TeamTrainingCancelNotice";
import TeamTrainingWriteForm from '@/components/mercenary/TeamTrainingWriteForm'
import { MATCH_REPEAT_SCHEDULE_IDX, REPORT_TYPE_IDX, JOIN_CHAT_TYPE, TEAM_TYPE } from "../../Constants";
import NaverMap from '@/modules/NaverMap';

const VIEW_TYPE = {
    INFO: 'INFO',
    REVIEW: 'REVIEW',
    HISOTRY: 'HISTORY'
}

export default {
    name: 'TeamTrainingDetail',
    components: {
        TeamTrainingCancelNotice,
        swiper, ShareSchedule, swiperSlide, BookmarkPopup, ProfileImage, EditModalFrame, BottomPopupMenu, TeamTrainingWriteForm, TeamTrainingReviewWriteForm
    },
    props: {
        scheduleIdx: {
            type: [Number, String],
            default: -1
        },
    },
    mounted() {
        // setTimeout(() => {
        //     if (this.$refs.test.$el.offsetWidth >= 390) {
        //         this.isPaused = false;
        //     }
        // }, 2000);
    },
    created() {
        this.exitNow = this.$Once(this.exitNow);
        this.payAction = this.$Once(this.payAction);
        this.applyForFree = this.$Once(this.applyForFree);
        this.getScheduleDetail()

    },
    computed: {
        is_free() {
            return this.scheduleDetail && this.scheduleDetail.dues === '.0000'
        },
        isMeCreator() {
            return this.$GlobalStore.loginInfo().idx == this.scheduleDetail.creator_idx;
        },
        transDays() {
            const daysOfWeek = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
            let dayArray = this.repeatScheduleInfo.days.split(',').map(Number);  // "0,4" -> [0, 4]
            let result = dayArray.map(day => daysOfWeek[day]);

            return result.join(', ');
        },
        currentNotice() {
            return this.noticeList[this.currentIndex];
        },
    },
    beforeDestroy() {
        // 모든 setTimeout 정리
        this.timeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
    },
    data() {
        return {
            TEAM_TYPE: TEAM_TYPE,
            viewTypeList: [
                { title: '정보', type: VIEW_TYPE.INFO },
                { title: '리뷰', type: VIEW_TYPE.REVIEW },
                { title: '히스토리', type: VIEW_TYPE.HISTORY },
            ],
            teamTrainingScheduleList: [],
            historyList: [
                { date: '10월 14일', },
                { date: '10월 21일', },
                { date: '10월 24일', },
                { date: '10월 31일', },
                { date: '11월 1일', },
            ],
            selectedHistory: '10월 14일',
            isOpenReviewWriteForm: false,
            selectedSchedule: '',
            isPaused: true,
            isVisible: true,
            noticeList: [
            ],
            currentIndex: 0,
            WRITE_TYPE: WRITE_TYPE,
            isShowShareSchedule: false,
            swiperOption: {
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                curIndex: 0,
            },
            menuOptions: {},
            schedules: [],
            JOIN_STATE: JOIN_STATE,
            bannerList: [
                { src: require('@/assets/img/join_banner.png',), name: '조인100% 활용' },
                { src: require('@/assets/img/join_banner.png',), name: '조인100% 활용' },
                { src: require('@/assets/img/join_banner.png',), name: '조인100% 활용' },
                { src: require('@/assets/img/join_banner.png',), name: '조인100% 활용' },
            ],
            sliderImage: [],
            groundImages: [],
            scheduleDetail: [],
            repeatScheduleInfo: [],
            isPassDay: false,
            isRepeat: false,
            scheduleMembers: [],
            isShowRefund: false,
            isShowPopMenu: false,
            introduce: [],
            amt: 0,
            isJoined: true,
            isShowWriteForm: false,
            replyList: [],
            join_schedule_history: {},
            join_schedule_history_image_index: [0, 1, 2, 3, 4],
            isWriteHistory: true,
            isWriteReview: true,
            join_schedules_history_not_created: [],
            join_schedules_review_not_created: [],
            timeoutIds: [],
            containerWidth: 0,
            isWrittenPreviousHistory: false,
            repeatScheduleIdx: null,
            viewType: VIEW_TYPE.INFO,
            VIEW_TYPE: VIEW_TYPE,
            historiesGrouped: [],
            skillList: [
                { level: '하', percent: 66, cnt: 2 },
                { level: '중하', percent: 0, cnt: 0 },
                { level: '중', percent: 33, cnt: 1 },
                { level: '중상', percent: 0, cnt: 0 },
                { level: '상', percent: 0, cnt: 0 },
            ],
            careerList: [
                { level: '1년 미만', percent: 33, cnt: 1 },
                { level: '1~2년', percent: 66, cnt: 2 },
                { level: '2~5년', percent: 0, cnt: 0 },
                { level: '5~9년', percent: 0, cnt: 0 },
                { level: '10년 이상', percent: 0, cnt: 0 },
            ],
            teamLevel: '',
            teamCareer: '',
            isClosed: false,
            naverMap: null,
            isShowReportPopup: false,
            isShowSexPopup: false,
            isShowFreeTrainingPop: false,
            isShowCompletePopup: false
        }
    },
    methods: {
        async showChat() {
            await this.$Axios.showPersonalChat(this.scheduleDetail.creator.member_idx, this.scheduleDetail.creator.member_type, JOIN_CHAT_TYPE.SINGLE);
            this.closeCompletePopup()
        },
        closeCompletePopup() {
            this.isShowCompletePopup = false
        },
        setIsShowCompletePopup() {
            this.isShowCompletePopup = true
        },
        showInBrowser() {
            this.$Util.sendEventClick('사커하우_트레이닝길찾기');
            const url = `https://map.naver.com?lng=${this.scheduleDetail.gps_longitude}&lat=${this.scheduleDetail.gps_latitude}&title=${encodeURIComponent(this.scheduleDetail.place_name)}`;
            // const url = 'https://www.naver.com'
            this.$Util.showBrowser(url);
        },
        reportTraining() {
            this.$Util.sendEventClick('사커하우_트레이닝신고')
            this.$GlobalStore.addModal('ReportPopup',
                {
                    target_member_idx: this.scheduleDetail.creator.member_idx,
                    target_member_type: this.scheduleDetail.creator.member_type,
                    refer_type: REPORT_TYPE_IDX.TEAM_TRAINING,
                    refer_idx: this.scheduleDetail.idx,
                    report_title: this.scheduleDetail.title,
                    report_contents: this.scheduleDetail.contents,
                    title: '트레이닝 신고하기',
                    reportType: 'training'
                }
            );
        },
        setMap() {
            this.$nextTick(() => {
                this.naverMap = new NaverMap();
                const options = {
                    pinchZoom: false,
                    scrollWheel: false,
                    draggable: false,
                };
                console.log(this.scheduleDetail)
                this.naverMap.initMap('place_map', this.scheduleDetail.gps_latitude, this.scheduleDetail.gps_longitude, options);
                this.naverMap.setCenterMarker(this.scheduleDetail.gps_latitude, this.scheduleDetail.gps_longitude);
            })
        },
        transText(beginTime, maxCnt, curCnt) {
            const now = moment();
            const startTime = moment(beginTime, "YYYY-MM-DD HH:mm:ss.SSS");

            const diffInHours = startTime.diff(now, 'hours');
            const isLeftTwo = parseInt(maxCnt) - parseInt(curCnt) <= 2;
            const isFull = parseInt(curCnt) >= parseInt(maxCnt);

            if (diffInHours < 0 || isFull) { // 시간이 지났거나 인원이 꽉 찬 경우
                this.isClosed = true
                return "참여 불가!";
            }

            if (this.is_free) {
                return '무료 체험기회!';
            }

            if (diffInHours <= 24 || isLeftTwo) { // 시작 시간 24시간 이내이거나 인원이 2명 이하로 남은 경우
                return "곧 신청 마감!";
            }
            return "여유롭게 참여 가능!";
        },
        showInquiryPage() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.$GlobalStore.addModal('SoccerhowCustomerSupport')
        },
        async monthChangeHandler(date) {

            const parameters = {};
            parameters.begin_date = date
            parameters.end_date = date
            parameters.repeat_schedule_idx = this.repeatScheduleInfo.idx

            const res = await this.$Axios.get('/api/join/schedule/history/list', { params: parameters });
            const histories_grouped = res.data.histories_grouped
            this.join_schedule_history = Object.values(histories_grouped)[0]
        },
        selectSchedule(date, idx) {
            if (date === this.selectedSchedule) {
                return
            }
            this.selectedSchedule = date
            this.historiesGrouped = []
            this.getScheduleDetail(true, idx)
        },
        closeReviewWriteForm(isComplete = false) {
            if (isComplete) {
                this.getScheduleDetail()
            }

            this.isOpenReviewWriteForm = false
        },
        checkOffsetWidth() {
            this.isPaused = true;
            this.$nextTick(() => {
                const timeoutId = setTimeout(() => {
                    if (this.$refs.test.$el.offsetWidth >= this.containerWidth) {
                        this.isPaused = false;
                    } else {
                        this.isPaused = true;
                    }
                    this.startTimeout(this.isPaused);
                }, 1500);
                this.timeoutIds.push(timeoutId);
            });
        },
        startTimeout(isPaused) {
            if (!isPaused) {
                const firstTimeoutId = setTimeout(() => {
                    this.isPaused = true;
                }, 10000);
                this.timeoutIds.push(firstTimeoutId);

                const secondTimeoutId = setTimeout(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.noticeList.length;
                    this.checkOffsetWidth();
                }, 15000);
                this.timeoutIds.push(secondTimeoutId);
            } else {
                const timeoutId = setTimeout(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.noticeList.length;
                    this.checkOffsetWidth();
                }, 5000);
                this.timeoutIds.push(timeoutId);
            }
        },
        hideNotice() {
            this.isVisible = false;
            clearInterval(this.intervalId); // 컴포넌트가 파괴될 때 타이머 정리
        },
        showReviewWriteForm() {
            if (this.isWriteReview) {
                return
            }
            if (this.isWrittenPreviousHistory) {
                this.isOpenReviewWriteForm = true
            } else {
                this.isShowWriteForm = true
            }
        },
        async checkIsWriteReview() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx
            const res = await this.$Axios.get('/api/join/schedule/review/notcreated', { params: parameters });

            const join_schedules_review_not_created = res.data.join_schedules_review_not_created;
            const is_review_possible_without_history = res.data.is_review_possible_without_history;
            this.join_schedules_review_not_created = join_schedules_review_not_created

            if (this.join_schedules_review_not_created.length > 0 && is_review_possible_without_history) {
                if (this.join_schedules_review_not_created[0].idx == this.scheduleIdx) {
                    this.isShowWriteForm = true
                    this.isWriteReview = false
                }
            } else if (is_review_possible_without_history && this.join_schedules_history_not_created.length === 0) {
                // this.isShowWriteForm = true
                this.isWriteReview = false
                this.isWrittenPreviousHistory = true
            }
            else if (!is_review_possible_without_history) {
                this.isShowWriteForm = false
                this.isWriteReview = true
            }
        },
        async checkIsWriteHistory() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx
            const res = await this.$Axios.get('/api/join/schedule/history/notcreated', { params: parameters })

            const join_schedules_history_not_created = res.data.join_schedules_history_not_created
            this.join_schedules_history_not_created = join_schedules_history_not_created
            // this.join_schedules_history_not_created.push({ idx: 2477 })

            if (this.join_schedules_history_not_created.length > 0) {
                this.isWriteHistory = false
                // this.$GlobalStore.addModal("TeamTrainingWriteForm", { transitionName: 'bottom', isModalBackTransparent: true, writeType: WRITE_TYPE.HISTORY, scheduleIdx: join_schedules_history_not_created[0].idx })
            } else {
                this.isWriteHistory = true;
            }
        },
        refreshTeamTraining() {
            this.getScheduleDetail()
        },
        async getReplyList() {
            const parameters = {};
            if (this.isRepeat) {
                parameters.refer_idx = this.repeatScheduleInfo.idx;
            } else {
                parameters.parentIdx = this.scheduleIdx;
            }

            // parameters.parentIdx = '117';
            parameters.replyDeep = 1;
            parameters.parent_type = 'schedule';
            parameters.child_type = 'schedule';
            parameters.sort = 'desc';

            const res = await this.$Axios.get('/api/soccerhow/replies', { params: parameters })
            this.replyList = res.data.replies
        },
        async getNoticeList() {
            const parameters = {}

            parameters.refer_idx = this.repeatScheduleInfo.idx

            const res = await this.$Axios.get('/api/soccerhow/notice', { params: parameters })
            const noticeList = res.data.notice_list

            this.noticeList = noticeList
            if (this.noticeList.length > 0) {
                this.$nextTick(() => {
                    const containerEl = this.$el.querySelector(".notice-text-container");
                    this.containerWidth = containerEl.offsetWidth
                    this.checkOffsetWidth();
                })
            }
        },
        closeWriteForm(isComplete = false) {
            this.isShowWriteForm = false;
            if (isComplete) {
                this.getScheduleDetail()
                this.firstJoinCheck()
                this.getReplyList();
            }
        },
        showSchedule(idx) {
            this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: idx })
        },
        showReservation() {
            if (!this.$Util.checkLogin()) return;
            this.$GlobalStore.addModal('MyClassReservation', { mode: 2, join_schedule_idx: this.scheduleIdx, completeAction: () => { this.getScheduleDetail() } })
        },
        async firstJoinCheck() {
            const res = await this.$Axios.get('/api/join/repeat/schedule/joined/check')
            if (this.scheduleDetail.repeat_schedule_idx == MATCH_REPEAT_SCHEDULE_IDX) {
                this.isJoined = true;
            } else {
                this.isJoined = res.data.is_joined
            }
        },
        joinTraining() {
            this.isShowSexPopup = false
            this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '트레이닝 1회', amt: this.amt, isShowCancelNotice: true });
        },
        showPayment() {
            if (!this.$Util.checkLogin()) return;
            if (this.isClosed) {
                this.$GlobalStore.showAlert('신청이 마감되었습니다.');
                return
            }

            const amt = this.is_free ? 0 : parseInt(this.scheduleDetail.dues);

            this.amt = amt
            if (this.scheduleDetail.sex !== this.$GlobalStore.loginInfo().sex + '성' && this.scheduleDetail.sex !== '혼성') {
                this.isShowSexPopup = true
                return
            }

            this.addApplyTryCount();

            if (amt == 0) {
                this.isShowFreeTrainingPop = true;
            } else {
                this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '트레이닝 1회', amt: amt, isShowCancelNotice: true });
            }
        },
        async applyForFree() {
            this.isShowFreeTrainingPop = false;

            const parameters = {};
            parameters.join_schedule_idx = this.scheduleIdx;
            const res = await this.$Axios.post('/api/join/schedule/apply', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.getScheduleDetail()
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async addApplyTryCount() {
            const parameters = {};
            parameters.join_schedule_idx = this.scheduleDetail.idx;
            await this.$Axios.post('/api/join/schedule/add/try/count', parameters);
        },
        async payAction(pay_method, pay_mode, card_idx) {
            const parameters = {};
            parameters.pay_mode = pay_mode;
            // amt 실제결제금액
            parameters.amt = this.amt
            parameters.goods_name = '트레이닝 1회';
            parameters.card_idx = card_idx;
            // 해당되는 idx 
            parameters.join_schedule_idx = this.scheduleIdx;

            await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/join/schedule/apply', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/join/schedule/apply', converted_parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                    this.getScheduleDetail();
                    this.setIsShowCompletePopup();
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            })
        },
        closeRefund() {
            this.isShowRefund = false
        },
        modifyNowSchedule() {
            this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', { scheduleIdx: this.scheduleIdx, completeAction: () => { this.getScheduleDetail(false, null) } })
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true;
            const labelAndAction = [];
            console.log(this.scheduleDetail)
            if (this.isMeCreator && this.scheduleDetail.state == JOIN_STATE.OPEN) {
                labelAndAction.push(
                    {
                        label: '트레이닝 수정하기', action: () => {
                            this.modifyNowSchedule()
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            if (this.isMeCreator && this.scheduleDetail.state == JOIN_STATE.CLOSE) {
                labelAndAction.push(
                    {
                        label: '트레이닝 관리하기', action: () => {
                            this.showTeamTrainingMngDetail()
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            if (!this.isMeCreator) {
                if (!this.scheduleDetail.is_me_joined) {
                    labelAndAction.push(
                        {
                            label: '예약하기', action: () => {
                                this.isShowPopMenu = false
                                this.showPayment()
                            },
                        },
                    )
                } else {
                    labelAndAction.push(
                        {
                            label: '예약 취소하기', action: () => {
                                this.confirmExit()
                                this.isShowPopMenu = false;
                            },
                        },
                        {
                            label: '예약페이지 보기', action: () => {
                                this.isShowPopMenu = false
                                this.showReservation()
                            },
                        },
                    )
                }
            }

            labelAndAction.push(
                {
                    label: '공유하기', action: () => {
                        const device = this.$cookies.get('device');

                        let domain = '';
                        if (process.env.NODE_ENV === 'development') {
                            domain = 'http://192.168.0.203:8080';
                        } else {
                            if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                                domain = 'https://obyungear-user-test.ubiplus.co.kr';
                            } else {
                                domain = 'https://app.soccerhow.com';
                            }
                        }

                        let url = `${domain}/team?target=` + this.scheduleIdx;
                        console.log(url);
                        const message = '트레이닝';

                        if (device === 'android') {
                            const text = (message === "" ? "" : message + "\n") + url;
                            window.Android.shareUrl(text);
                        } else if (device === 'ios') {
                            /*eslint-disable no-undef */
                            webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
                        } else {
                            navigator.share({
                                title: message,
                                url: url
                            }).then(() => {
                                console.log('Thanks for sharing!');
                            }).catch(() => {
                                console.log('share error');
                            });
                        }

                        this.isShowPopMenu = false
                    }
                },
                {
                    label: '참여 취소 및 환불 규정 보기', action: () => {
                        this.isShowPopMenu = false
                        this.isShowRefund = true
                    }
                },
                {
                    label: '신고하기', action: () => {
                        this.isShowPopMenu = false
                        this.isShowReportPopup = true
                    }
                },
            );

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }

        },
        async exitNow() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleIdx)

            const res = await this.$Axios.post('/api/join/schedule/exit', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getScheduleDetail()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        confirmExit() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">트레이닝 예약 취소하기</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>예약은 수업 시작일 자정까지 무료로 취소할 수<br>있으며, 이후부터는 시간에 따라 환불 비율이 달라집니다.<br>자세한 내용은 규정을 통해 확인해주시기 바랍니다.<br>트레이닝 예약을 취소할까요?</div>`; this.$GlobalStore.showConfirm(html, () => {
                this.exitNow()
            }, '예약 취소하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        showImageViewer(index) {
            if (this.groundImages.length === 0) return
            const image_paths = this.groundImages.map((each) => each.src);
            this.$GlobalStore.addModal('ImageViewer', { imagePaths: image_paths, initIndex: index });
        },
        transDate(date) {
            if (date.split(' ')[0] === this.selectedDate) {
                return ''
            } else {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)

                return transDate.join(' ')
            }

        },
        showTeamTrainingMngDetail() {
            this.$GlobalStore.addModal('TeamTrainingMngDetail', { join_schedule_idx: this.scheduleDetail.idx })
        },
        async getScheduleDetail(isSelectSchedule = false, idx) {
            const parameters = {}
            parameters.join_schedule_idx = isSelectSchedule ? idx : this.scheduleIdx;
            parameters.is_visit = true;
            this.groundImages = []

            const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
            if (!res.data.join_schedules) {
                this.$GlobalStore.showAlert('삭제된 수업입니다.');
                this.$GlobalStore.closeLastModal();
                return
            }
            // skillList: [
            //     { level: '하', percent: 66, cnt: 2 },
            //     { level: '중하', percent: 0, cnt: 0 },
            //     { level: '중', percent: 33, cnt: 1 },
            //     { level: '중상', percent: 0, cnt: 0 },
            //     { level: '상', percent: 0, cnt: 0 },
            // ],
            const sliderImage = res.data.join_schedule_slider_images ?? []
            const scheduleDetail = res.data.join_schedules
            const scheduleMembers = res.data.join_schedule_members
            const groundImages = res.data.join_schedule_images ?? []
            const introduce = (res.data.join_schedule_introduce ? res.data.join_schedule_introduce.introduce ?? [] : []);
            const otherSchedules = res.data.join_schedule_other
            const opendRepeatJoinSchedules = res.data.opened_repeat_join_schedules
            const historyDate = res.data.history_dates
            const level_stats = res.data.level_stats
            const career_stats = res.data.career_stats

            const transNumberCareerStats = career_stats.map(Number)
            const transNumberLevelStats = level_stats.map(Number)
            const totalCareerStats = transNumberCareerStats.reduce((acc, num) => acc + num, 0)
            const totalLevelStats = transNumberLevelStats.reduce((acc, num) => acc + num, 0)
            const percentagesLevelStats = transNumberLevelStats.map(num => {
                return totalLevelStats === 0 ? 0 : Math.round((num / totalLevelStats) * 100)
            })
            const percentagesCareerStats = transNumberCareerStats.map(num => {
                return totalCareerStats === 0 ? 0 : Math.round((num / totalCareerStats) * 100)
            })
            // careerList: [
            //     { level: '1년 미만', percent: 33, cnt: 1 },
            //     { level: '1~2년', percent: 66, cnt: 2 },
            //     { level: '2~5년', percent: 0, cnt: 0 },
            //     { level: '5~9년', percent: 0, cnt: 0 },
            //     { level: '10년 이상', percent: 0, cnt: 0 },
            // ]
            percentagesCareerStats.forEach((item, index) => {
                this.careerList[index].percent = item
            })
            percentagesLevelStats.forEach((item, index) => {
                this.skillList[index].percent = item
            })
            career_stats.forEach((item, index) => {
                this.careerList[index].cnt = item
            })
            level_stats.forEach((item, index) => {
                this.skillList[index].cnt = item
            })
            const levels = ["하", "중하", "중", "중상", "상"];
            const careers = ["1년 미만", "1~2년", "2~5년", "5~9년", "10년 이상"]
            const maxValue = Math.max(...transNumberLevelStats);
            const maxValue2 = Math.max(...transNumberCareerStats);
            const maxIndex = transNumberLevelStats.indexOf(maxValue);
            const maxIndex2 = transNumberCareerStats.indexOf(maxValue2);
            const teamLevel = levels[maxIndex];
            const teamCareer = careers[maxIndex2];
            this.teamLevel = teamLevel
            this.teamCareer = teamCareer


            this.historiesGrouped = historyDate

            this.teamTrainingScheduleList = opendRepeatJoinSchedules
            this.selectedSchedule = scheduleDetail.join_begin_date_time

            for (let i = 0; i < 5; i++) {
                if (groundImages['image_path' + i]) {
                    this.groundImages.push({ src: groundImages['image_path' + i] })
                }
            }

            const filteredMembers = scheduleMembers.filter(item =>
                parseInt(item.member_idx) !== scheduleDetail.creator.member_idx
            );

            this.scheduleDetail = scheduleDetail

            this.firstJoinCheck()

            this.schedules = otherSchedules
            this.introduce = introduce
            this.sliderImage = sliderImage
            this.repeatScheduleInfo = res.data.repeat_schedule
            this.scheduleDetail.cur_cnt = parseInt(this.scheduleDetail.cur_cnt) - 1
            this.scheduleDetail.max_cnt = parseInt(this.scheduleDetail.max_cnt) - 1
            this.isPassDay = this.checkIsPassDay(this.scheduleDetail.join_begin_date_time)
            this.isRepeat = res.data.repeat_schedule ? true : false
            this.scheduleMembers = filteredMembers
            // 테스트용
            // this.scheduleDetail.cur_cnt = 2
            // this.scheduleDetail.max_cnt = 10
            // this.scheduleDetail.join_begin_date_time = '2025-03-18 13:00:00.000'

            this.join_schedule_history = res.data.join_schedule_history;
            if (this.join_schedule_history) {
                this.selectedHistory = this.join_schedule_history.history_date
            }

            if (this.repeatScheduleInfo) {
                this.getNoticeList()
                this.repeatScheduleIdx = this.repeatScheduleInfo.idx
                // this.monthChangeHandler()
            }

            this.getReplyList();

            if (!this.$GlobalStore.isLogin()) return;

            if (this.scheduleDetail.is_me_joined && this.$GlobalStore.loginInfo().is_coach == '0') {
                this.checkIsWriteReview()
            } else if (this.scheduleDetail.creator.member_idx == this.$GlobalStore.loginInfo().idx && this.$GlobalStore.loginInfo().is_coach == 1) {
                this.checkIsWriteHistory()
            }

            this.setMap()

            // this.scheduleDetail.is_me_joined = true
        },
        checkIsPassDay(joinDate) {
            const currentDate = moment()
            const givenDate = moment(joinDate, 'YYYY-MM-DD HH:mm:ss.SSS')

            if (currentDate.isBefore(givenDate)) {
                return false
            } else if (currentDate.isAfter(givenDate)) {
                return true
            } else {
                return true
            }
        },
    }
}
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-up-enter,
.slide-up-leave-to {
    transform: translateY(-100px);
    /* 위로 슬라이드 */
    opacity: 0;
}

.un_active {
    background-color: #bbbbbb;
    color: #fff;
}

.active {
    background-color: var(--color-main);
    color: #210f03;
}

.circle_linear {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(180deg, #FF7111 0%, #FFDD31 100%);
    position: relative;
}

.inner_circle {
    position: absolute;
    width: 56px;
    height: 56px;
    background-color: #f5f5f5;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.text_gradient {
    background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);
    -webkit-background-clip: text;
    color: transparent;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.float_btn {
    background: #210F03E5;
    width: 100%;
    height: 58px;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    color: #fff;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    backdrop-filter: blur(2px);
    box-shadow: 0px 0px 10px 0px #FFFFFF80;

}

.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}

.swiper .swiper-pagination {
    position: absolute;
    bottom: 65px !important;
}

.swiper-pagination-bullet {
    background: red !important;
    width: 6px;
    height: 6px;
    opacity: 1;
}

.swiper-pagination-bullet-active {
    background: #fff !important;
}

.cont_wrap_box {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #ededed;
    padding-right: 16px;
}

.title {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #210f03;
}

.sub_title {
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    color: #606060;
}

.sub_title2 {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}

.title2::after {
    content: '';
    width: 100%;
    height: 8px;
    background-color: #FFEC8A;
    position: absolute;
    bottom: -3px;
    left: 0;
    z-index: -1;
}

.notice-container {
    width: calc(100% - 24px);
    left: 50%;
    padding: 8px 12px;
    transform: translateX(-50%);
    position: absolute;
    background: #f5f5f5e5;
    height: 40px;
    z-index: 10;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.notice-content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.notice-label {
    width: 38px;
    height: 24px;
    line-height: 24px;
    border-radius: 21px;
    text-align: center;
    color: #fff;
    background-color: #210f03;
    font-size: 12px;
    font-weight: 700;
}

.notice-text-container {
    position: relative;
    flex: 1;
    height: 24px;
    overflow: hidden;
    display: flex;
    align-items: center;
}

.notice-text {
    position: absolute;
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    white-space: nowrap;
}

.scroll-content {
    display: inline-block;
    /* padding-right: 100%; */
    /* 텍스트 간격 조절 */
}

/* 애니메이션 정의 */
</style>